/**
 * Design tokens — Mon Ministère
 * Identité visuelle officielle : dark premium, or chaleureux, sobre et spirituel.
 */

export const colors = {
  // ─── Fonds ───
  bg:          "#050709",  // fond principal très sombre
  surface:     "#0A0D14",  // fond des sections
  card:        "#0F1520",  // fond des cartes
  border:      "#1E2A3E",  // bordures

  // ─── Or (couleur signature) ───
  gold:        "#E4A72C",  // or principal
  goldLight:   "#F5C55A",  // or clair (utilisé dans les dégradés)
  goldDim:     "#E4A72C18",// or transparent (overlays subtils)
  goldBorder:  "#E4A72C35",// or pour les bordures sur fond sombre

  // ─── Texte ───
  text:        "#F0EDE6",  // texte principal (légèrement crème)
  textMuted:   "#8A97B0",  // texte secondaire
  textDim:     "#3A4860",  // texte discret / placeholder

  // ─── Statuts ───
  green:       "#2DD4A0",  // succès
  rose:        "#E05B6A",  // erreur / danger
  blue:        "#60A5FA",  // information

  // ─── Alias rétrocompatibilité (anciens consommateurs) ───
  textBright:  "#FFFFFF",
  cardHover:   "#141B27",
  goldDark:    "#B8861F",
  muted:       "#8A97B0",  // alias de textMuted
  mutedDark:   "#3A4860",  // alias de textDim
  borderLight: "#1E2A3E",  // alias de border
  success:     "#2DD4A0",  // alias de green
  danger:      "#E05B6A",  // alias de rose
  info:        "#60A5FA",  // alias de blue
  warning:     "#E4A72C",  // pas de warning dédié → mappé sur gold
  overlay:     "rgba(5, 7, 9, 0.85)",
  goldOverlay: "#E4A72C18",
};

/** Dégradé or canonique (utilisé pour le logo, les boutons primaires, badges or). */
export const goldGradient = "linear-gradient(135deg, #E4A72C 0%, #F5C55A 100%)";

export const fonts = {
  heading: "'Cormorant Garamond', serif",
  body:    "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
  mono:    "'JetBrains Mono', 'Fira Code', monospace",
};

export const fontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  base: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
};

export const fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  black: 900,
};

export const spacing = {
  0: "0",
  1: "0.25rem", 2: "0.5rem", 3: "0.75rem", 4: "1rem",
  5: "1.25rem", 6: "1.5rem", 8: "2rem", 10: "2.5rem",
  12: "3rem",   16: "4rem",  20: "5rem", 24: "6rem",
};

export const radii = {
  none: "0",
  sm: "0.375rem",
  md: "0.5rem",
  lg: "0.75rem",
  xl: "1rem",
  "2xl": "1.5rem",
  full: "9999px",
};

export const shadows = {
  sm: "0 1px 2px rgba(0,0,0,0.4)",
  md: "0 4px 12px rgba(0,0,0,0.5)",
  lg: "0 10px 30px rgba(0,0,0,0.6)",
  xl: "0 25px 50px rgba(0,0,0,0.7)",
  gold:        "0 4px 20px rgba(228, 167, 44, 0.25)",
  goldStrong:  "0 8px 32px rgba(228, 167, 44, 0.45)",
};

export const transitions = {
  fast: "all 150ms cubic-bezier(0.4, 0, 0.2, 1)",
  base: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
  slow: "all 400ms cubic-bezier(0.4, 0, 0.2, 1)",
};

export const breakpoints = {
  sm: "640px", md: "768px", lg: "1024px", xl: "1280px", "2xl": "1536px",
};

export const zIndex = {
  base: 0, dropdown: 100, sticky: 200, overlay: 300,
  modal: 400, popover: 500, toast: 600,
};

/** Slogan officiel utilisé sous le logo. */
export const TAGLINE = "Gérez votre église · Libérez votre ministère";

const tokens = {
  colors, goldGradient, fonts, fontSizes, fontWeights,
  spacing, radii, shadows, transitions, breakpoints, zIndex, TAGLINE,
};

export default tokens;
